import Vue from 'vue'
import App from './components/AppBase.vue'
import router from './router'
import store from './store'
import ApiCall from './common/api.service'

// Meta data.
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
// Social package
import VueSocialSharing from 'vue-social-sharing'
Vue.use(VueSocialSharing)
// Boot strap
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
// Maps
import { Icon } from 'leaflet'
// import 'leaflet.icon.glyph'
import 'leaflet/dist/leaflet.css'

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

ApiCall.init()

//if (document.getElementById('search-vue-app')) {
new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#search-vue-app')
//}
